import { Theme } from '@mui/material/styles';

import { IconCell } from '@/components/Icon/IconCell';

import { useResponsive } from '@/hooks/useResponsive';

import { ConfirmDrawerProps } from './Drawer.interface';
import { InfoDrawer } from './InfoDrawer';

export function ConfirmDrawer({
  icon = 'info-outline',
  iconColor = (theme: Theme) => theme.palette.orange[400],
  drawerImage,
  ...props
}: ConfirmDrawerProps) {
  const { isMobile, isTablet } = useResponsive();

  return (
    <InfoDrawer
      drawerImage={
        drawerImage ??
        (isMobile && !isTablet ? (
          <IconCell name={icon} size={96} iconSize={48} bgColor={iconColor} />
        ) : undefined)
      }
      {...props}
    />
  );
}
